/**
 * Centralized guided tour steps for all pages
 * Each tour is an array of steps with element selector and popover content
 */

export const TOURS = {
  // Overview Tab Tour (PlanDetail page)
  OVERVIEW_TAB: [
    {
      element: '[data-tab="overview"]',
      translationKey: 'overviewTab',
      popover: {
        title: 'Overview Tab',
        description: 'This is your trip overview with summary, dates, to-do list, and more.',
        side: 'bottom',
        align: 'start'
      }
    },
    {
      element: '[data-tab="days"]',
      translationKey: 'daysTab',
      popover: {
        title: 'Days Tab',
        description: 'This is the main and most important tab for organizing your itinerary. Here you can view and manage all your daily activities, add new ones, and organize your trip day by day.',
        side: 'bottom',
        align: 'start'
      }
    },
    {
      element: '#edit-details-btn',
      translationKey: 'editDetails',
      popover: {
        title: 'Edit Details',
        description: 'Click here to edit your trip name, description, and destination.',
        side: 'bottom',
        align: 'start'
      }
    },
    {
      element: '#edit-dates-btn',
      translationKey: 'editDates',
      popover: {
        title: 'Edit Dates',
        description: 'Update your trip start and end dates here. Changes will reorganize your itinerary.',
        side: 'bottom',
        align: 'start'
      }
    },
    {
      element: '#all-todos-section',
      translationKey: 'todoItems',
      popover: {
        title: 'To-Do Items',
        description: 'Manage your trip to-do list - add tasks, check them off as you complete them.',
        side: 'top',
        align: 'start'
      }
    }
  ],
  
  // Days Tab Tour (PlanDetail page)
  DAYS_TAB: [
    {
      element: '.first-day-actions-btn',
      translationKey: 'dayActions',
      popover: {
        title: 'Day Actions',
        description: 'Use "Add Activity" to easily add activities with AI. You can also view "Suggested Activities" or see all activities on the "Map".',
        side: 'bottom',
        align: 'start'
      }
    },
    {
      element: '#plan-actions-dropdown, #desktop-actions-buttons',
      translationKey: 'shareActions',
      popover: {
        title: 'Share & Actions',
        description: 'Access options like Minimize View, Share, Share to Group, Print, and more. On mobile, use the menu (⋮) for more options.',
        side: 'bottom',
        align: 'start'
      }
    }
  ],
  
  // AI Plan Creator Tour (for new users)
  AI_PLAN_CREATOR: [
    {
      popover: {
        title: 'Welcome to trip147! 🎉',
        description: 'Let\'s create your first trip together! This tour will guide you through the process.',
        side: 'left',
        align: 'start'
      }
    },
    {
      element: '#trip-description',
      popover: {
        title: 'Describe Your Trip',
        description: 'Tell us where you want to go and what you want to do. Be as detailed or as brief as you like!',
        side: 'bottom',
        align: 'start'
      }
    },
    {
      element: '#trip-dates',
      popover: {
        title: 'Set Your Dates',
        description: 'Choose your travel dates. Don\'t worry - you can change them later!',
        side: 'bottom',
        align: 'start'
      }
    },
    {
      element: '#smart-itinerary-checkbox',
      popover: {
        title: 'Smart Itinerary (Recommended)',
        description: 'Turn this ON to let AI create a day-by-day plan with attractions. Perfect for new trips!',
        side: 'left',
        align: 'start'
      }
    },
    {
      element: '#generate-plan-btn',
      popover: {
        title: 'Generate Your Trip',
        description: 'Click here when you\'re ready and AI will create your personalized itinerary. It takes about 30-60 seconds. ✨',
        side: 'top',
        align: 'center'
      }
    }
  ]
};

